import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/browser';
import { HelmetProvider } from 'react-helmet-async';

import { App } from '@/App';
import { store, persistor } from '@/store';
import { isProduction, isStaging } from '@/settings/environment';
import '@/settings/i18n';
import { instance } from '@/services/api/axios/instance';
import { setUp } from '@/services/api/axios/interceptors';

// styles
import 'react-datepicker/dist/react-datepicker.css';
import '@/styles/common.css';
import '@/styles/index.css';

if (isProduction() || isStaging()) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_GIT_SHA,
    environment: process.env.REACT_APP_ENV,
    ignoreErrors: ['window.zE is not a function'],
  });
}

setUp(instance);

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <App />
          </Router>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
);
